import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.store('sweepId', 'Lander', 'cms/posts', POST_CONFIGURATION)
      .multi(true),
    filter
      .options.list('active', 'Status', STATUS_OPTIONS),
    filter
      .options.list('winnerFrequency', 'Frequency', FREQUENCY_OPTIONS)
      .multi(true),
    filter
      .options.list('reg_mode', 'Registration Mode', REGISTRATION_OPTIONS)
      .multi(true),
    filter
      .options.list('$and', 'Entries', ENTRIES_OPTIONS)
      .multi(false)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
  ], [])
}

const POST_CONFIGURATION = {
  params: { content_type: 'sweep' },
  parserOptions: { labelKey: 'title', valueKey: 'id' },
}

const STATUS_OPTIONS = [
  { label: "Active", value: "true" },
  { label: "Finished", value: "false" },
]

const FREQUENCY_OPTIONS = [
  { value: 'd', label: 'Daily' },
  { value: 'w', label: 'Weekly' },
  { value: 'M', label: 'Monthly' },
  { value: 'y', label: 'Yearly' },
  { value: 'Q', label: 'Quarterly' },
  { value: 'S', label: 'Semi-yearly' },
  { value: 'static', label: 'Just Once' },
]

const REGISTRATION_OPTIONS = [
  { label: "All registrations", value: "all" },
  { label: "E-mail Confirmation", value: "confirmation" },
]

const ENTRIES_OPTIONS = [
  { label: "Has entries", value: `{"optins":{"$gt":0}}` },
  { label: "No entries", value: `{"optins":{"$eq":0}}` },
  { label: "Has confirmed entries", value: `{"confirmedOptins":{"$gt":0}}` },
  { label: "No confirmed entries", value: `{"confirmedOptins":{"$eq":0}}` },
]
